
import { defineComponent, PropType, ref } from 'vue'
import QForm from 'quasar/src/components/form/QForm.js';
import { useFormModule } from '@/modules/_shared/forms'
import { AgreementMember, useAgreementModule } from '@/modules/agreements'
import AgreementFormFieldNewMember from '@/components/agreements/form-fields/new-member.vue'

export default defineComponent({
    name: 'agreement-swap-member',
    components: { AgreementFormFieldNewMember },
    props: {
        agreementId: {
            type: String,
            required: true
        },
        member: {
            type: Object as PropType<AgreementMember>,
            required: true
        },
        closeDialogCallback: {
            type: Function as PropType<() => void>,
            required: true
        }
    },
    setup (props) {
        const { submitForm, createOnSuccess } = useFormModule()
        const { swapAgreementMember, getAgreementMembers, getAgreementAvailableMembers } = useAgreementModule()

        const form = ref<QForm>()
        const newMemberModel = ref('')
        const closePopupModel = ref(false)

        const sendRequest = async () => await swapAgreementMember(props.agreementId, {
            agreementId: props.agreementId,
            accessId: props.member.accessId,
            newMemberId: newMemberModel.value
        })

        const onSubmit = () => submitForm(
            form.value,
            sendRequest,
            createOnSuccess('Member access has been swapped')
        ).then(() => {
            props.closeDialogCallback()
            getAgreementMembers(props.agreementId)
            getAgreementAvailableMembers(props.agreementId)
        })

        return {
            newMemberModel,
            closePopupModel,
            onSubmit,
            form
        }
    }
})
